module.exports = __webpack_public_path__ + "media/images/blue-dad-and-kid-6ba5d96a72885643b1bc4109991c281f.png";